export default __webpack_public_path__ + "static/media/tap-performance.af65881f.svg";